import { createStore } from "vuex";
import axios           from "axios";
import { flatMap }     from "lodash-es";


axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

let state =
        {
            copydeck  : {},
            pageTitle : "",

            articles                  : [],
            filteredArticles          : [],
            filteredPaginatedArticles : [],

            categories : [],
            sortOrder  : "date",
            layoutMode : 'list',

            allFilters          : {},
            copydeckDateFilters : [],
            filtersCategories   : [],
            filtersDate         : [],


            pagination : {
                resultsPerPage   : 0,
                totalPages       : 0,
                currentPage      : 0,
                lastPage         : 0,
                numResults       : 0,
                hasMultiplePages : false,
            },

            appReady : false,

            isMobile : false,
        };

let getters =
        {

            appReady ( state )
            {
                return state.appReady;
            },

            articles ( state )
            {
                return state.articles;
            },

            categories ( state )
            {
                return state.categories;
            },

            filtersCategories ( state )
            {
                return state.filtersCategories;
            },

            filtersDate ( state )
            {
                return state.filtersDate;
            },

            copydeck ( state )
            {
                return state.copydeck;
            },

            filteredArticles ( state )
            {
                // @todo temp
                return state.filteredArticles;
                // return state.articles;
            },

            filteredPaginatedArticles ( state )
            {
                return state.filteredPaginatedArticles;
            },

            copydeckDateFilters ( state )
            {
                return state.copydeckDateFilters;
            },


            allFilters ( state )
            {
                return state.allFilters;
            },

            sortOrder ( state )
            {
                return state.sortOrder;
            },

            pagination ( state )
            {
                return state.pagination;
            },

            layoutMode ( state )
            {
                return state.layoutMode;
            },

            isMobile(state) {
                return state.isMobile;
            },
            isDesktop(state) {
                return !state.isMobile;
            }
        };


let actions =
        {
            async search ( { commit }, searchterm )
            {

                let params   = "?s=" + searchterm;
                let response = await axios.get( "/endpoints/search" + params );

                commit( "results", response.data );
            },


            appReady ( { commit, state }, payload )
            {
                commit( "appReady", true );
            },
        }


let mutations =
        {
            copydeck ( state, payload )
            {
                state.copydeck = payload;

                state.allFilters.dates          = payload?.articles?.dateFilters?.fr;
                state.pagination.resultsPerPage = parseInt( payload?.articles?.resultsPerPage?.fr ) ?? 15;
            },

            articles ( state, payload )
            {
                let adjusted = [];

                payload = payload.map( ( article ) =>
                {

                    article.catCleanedId = article?.categories?.[ 0 ]?.id ?? 0;

                    return article;
                } );


                state.articles = payload;
            },

            categories ( state, payload )
            {


                state.categories            = payload;
                state.allFilters.categories = state.categories;
            },

            pageTitle ( state, payload )
            {
                state.pageTitle = payload;
            },

            allFilters ( state, payload )
            {

                state.allFilters.categories.map( el => el.active = false );
                state.allFilters.dates.map( el => el.active = false );

            },


            resetFilters ( state )
            {
                state.allFilters.categories.map( el => el.active = false );
                state.allFilters.dates.map( el => el.active = false );

            },


            sortOrder ( state, payload )
            {
                state.sortOrder = payload;
            },

            filteredArticles ( state, payload )
            {

                state.filteredArticles = payload;

            },

            filteredPaginatedArticles ( state, payload )
            {

                state.filteredPaginatedArticles = payload;

            },


            checkFilter ( state, payload )
            {

                state.allFilters[ payload.type ].find( fi => fi.id === payload.id ).active = payload.active;

            },

            appReady ( state, payload )
            {
                state.appReady = payload;
            },

            forceActivateCategory ( state, payload )
            {

                state.allFilters.categories.find( f => f.id === payload ).active = true;

            },

            pagination ( state, payload )
            {
                state.pagination = payload;
            },


            currentPage ( state, payload )
            {
                state.pagination.currentPage = payload;
            },

            layoutMode ( state, payload )
            {
                state.layoutMode = payload;
            },

            setMobileMode(state, payload) {
                state.isMobile = payload;
            }
        }


export default createStore( { state, getters, actions, mutations } );

